ç<template>
    <BCard>
        <ValidationObserver ref="form" #default="{ invalid }">
            <BForm @submit.prevent="onSubmit">
                <BRow>
                    <TextInputValidated vsName="Code" :vsModel.sync="data.code" vsMd="6" vsRequired vsRules="required"/>
                    <TextInputValidated vsName="Name" :vsModel.sync="data.name" vsMd="6" vsRequired vsRules="required"/>
                    <NumberInputValidated  vsName="Matrícula" :vsModel.sync="data.amount" vsMd="6" vsRequired vsStep="0.01" vsRules="required"/>
                    <NumberInputValidated vsName="Places" :vsModel.sync="data.places" vsMd="6" vsRequired vsRules="required" />
                    <vSelectValidated vsName="Group" v-if="groups && groups.length>1" :vsModel.sync="data.group_id" :vsOptions="groups" :vsReduce="group => group.id"  vsLabel="name" vsMd="6" :vsClearable="true"/>
                    <vSelectValidated vsName="Section"  :vsModel.sync="data.section_id" :vsOptions="sections" :vsReduce="section => section.id" vsLabel="name"  vsMd="6" vsRequired vsRules="required"/>
                    <vSelectValidated vsName="Tax" :vsModel.sync="data.tax_id"  :vsOptions="taxes" :vsReduce="tax => tax.id" vsLabel="name" vsMd="6" vsRequired vsRules="required"/>
                    <DatepickerValidated vsName="Enrollment start date" :vsModel.sync="data.enrollment_start_date" vsMd="6" vsRequired vsRules="required" />
                    <DatepickerValidated vsName="Enrollment end date" :vsModel.sync="data.enrollment_end_date" vsMd="6"  :vsMin="data.enrollment_start_date" />

                    <BCol cols="12">
                        <BFormGroup label="Opciones de pago" v-slot="{ ariaDescribedby }">
                            <BCol>
                                <BRow>
                                    <BFormRadio v-model="paymentType" class="mr-2" :aria-describedby="ariaDescribedby" name="some-radios" value="mensual">Pago mensual</BFormRadio>
                                    <BFormRadio v-model="paymentType" :aria-describedby="ariaDescribedby" name="some-radios" value="plazos">Pago a plazos</BFormRadio>
                                </BRow>
                            </BCol>
                        </BFormGroup>
                    </BCol>


                    <!-- Pago mensual -->
                    <BCol cols="12" v-if="paymentType=='mensual'">
                        <BRow>
                            <NumberInputValidated vsName="Mensualidad" :vsModel.sync="data.monthly_payment" vsMd="6" vsStep="0.01" vsRequired :vsRules="  paymentType=='mensual' ? 'required':''"/>
                            
                            <div class="d-none d-md-block col-md-6"></div>
                            <DatepickerValidated vsName="Start date" :vsModel.sync="data.start_date" vsMd="6" vsRequired :vsRules="paymentType=='mensual' ? 'required':''"/>
                            <DatepickerValidated vsName="End Date" vsReset :vsModel.sync="data.end_date" vsMd="6" :vsMin="data.start_date"/>
                            <vSelectValidated vsName="Porcentaje del primer mes" :vsOptions="percentageOptions" :vsModel.sync="data.first_month_percentage" :vsReduce="percentage => percentage.value" vsLabel="name" vsMd="6" vsRequired :vsRules="paymentType=='mensual' ? 'required':''" />
                            <vSelectValidated vsName="Porcentaje del último mes" vsReset v-if="data.end_date" :vsClearable="true" :vsOptions="percentageOptions" :vsModel.sync="data.last_month_percentage" :vsReduce="percentage => percentage.value" vsLabel="name" vsMd="6"  />
                        </BRow>
                    </BCol >

                    <!-- Pago a plazos -->
                    <DatepickerValidated vsRequired :vsRules="paymentType=='plazos' ? 'required':''" v-if="paymentType=='plazos'" vsName="Fecha de alta del curso" :vsModel.sync="data.start_date" vsMd="6"  />
                    <DatepickerValidated vsRequired :vsRules="paymentType=='plazos' ? 'required':''" :vsMin="terms[terms.length-1] ? terms[terms.length-1].start_date : ''" v-if="paymentType=='plazos'" vsName="Fecha de baja del curso" :vsModel.sync="data.end_date" vsMd="6"  />
                    <BCol cols="12" v-if="paymentType=='plazos'" >

                        <div class="repeater-form ">  
                            <BRow v-for="(term, index) in terms" :key="index" class="border rounded p-1 my-1">
                                <BCol cols="12"> 
                                    <BRow> 
                                        <BCol> 
                                            <p>Plazo {{ index+1 }}</p> 
                                        </BCol> 
                                    <feather-icon @click="removeTerm(index)" size="16" icon="XIcon" class="cursor-pointer"/>
                                    </BRow>
                                </BCol>

                                <BCol>
                                    <BRow>
                                        <DatepickerValidated vsName="Start date" :vsModel.sync="term.start_date" vsMd="6" vsRequired vsRules="required" :vsRules="paymentType=='plazos' ? 'required':''" :vsMin=" terms[index-1] ? terms[index-1].start_date: (data.start_date ? data.start_date : '')"/>
                                        <NumberInputValidated vsName="Amount" :vsModel.sync="term.term_payment" vsStep="0.01" vsMd="6" vsRequired vsRules="required" :vsRules="paymentType=='plazos' ? 'required':''"/>
                                    </BRow>
                                </BCol>
                                
                            </BRow>
                        </div>
                        <BButton @click="addNewTerm" class="m-1" size="sm" variant="primary"> Añadir plazo </BButton>
                    </BCol>
                    <CheckboxValidated vsName="show_tpv" vsLabel="Show in TPV" :vsModel.sync="data.show_tpv" />
                    <CheckboxValidated vsName="show_student_tpv" vsLabel="Show in student TPV" :vsModel.sync="data.show_student_tpv" />
                </BRow>
                <BRow class="mt-3">
                    <BCol>
                        <BButton class="mb-1 mb-sm-0 mr-0 mr-sm-1" variant="primary" type="submit" :block="$store.getters['app/currentBreakPoint'] === 'xs'" id="submitbutton"> {{ $t('Save Changes') }} </BButton>
                        <BButton variant="outline-secondary" :block="$store.getters['app/currentBreakPoint'] === 'xs'" :to="{ name:'courses' }"> {{ $t('Cancel') }} </BButton>
                    </BCol>
                </BRow>
            </BForm>
        </ValidationObserver>
    </BCard>
</template>

<script>
import { BCard, BForm, BRow, BCol, BFormGroup, BFormInput, BFormInvalidFeedback, BButton, BFormDatepicker, BFormRadio } from 'bootstrap-vue';
import { ValidationProvider, ValidationObserver, extend } from 'vee-validate';
import { onUnmounted, ref, watch} from '@vue/composition-api';
import { numeric, required } from 'vee-validate/dist/rules';
import formValidation from '@core/comp-functions/forms/form-validation';
import TextInputValidated from '@/components/forms/TextInputValidated.vue';
import vSelectValidated from '@/components/forms/vSelectValidated.vue';
import NumberInputValidated from '@/components/forms/NumberInputValidated.vue';
import DatepickerValidated from '@/components/forms/DatepickerValidated.vue';;
import CheckboxValidated from '@/components/forms/CheckboxValidated.vue';
import courseModule from '../courseModule'
import popups from '@/hooks/popups'
import VSelect from 'vue-select';
import router from '@/router';
import store from '@/store';
import axios from '@axios'


export default {
    components: { DatepickerValidated, NumberInputValidated, TextInputValidated, vSelectValidated, BCard, BForm, BRow, BFormRadio,  BCol, BFormGroup, BFormInput, BFormInvalidFeedback, BButton, ValidationObserver, ValidationProvider, BFormDatepicker, VSelect, CheckboxValidated },
    setup() {
    const { getValidationState } = formValidation()
    const { errorToast, successToast } = popups()
    const COURSES_MODULE = 'courses'
    const form = ref(null)
    const groups = ref([])
    const sections = ref([])
    const taxes = ref([])
    const data = ref({
        id:null,
        code: '',
        name: '',
        group: '',
        section: '',
        amount: '',
        monthly_payment: '',
        start_date: null,
        end_date: null,
        enrollment_start_date: null,
        enrollment_end_date: null, 
        status: null,
        show_tpv: false,
        show_student_tpv: false,
        first_month_percentage: null,
        last_month_percentage: null,
        first_month_payment: '',
        last_month_payment: '',
    })
    const term={
        course_id:null,
        start_date: null,
        term_payment:null
    }
    const terms=ref([JSON.parse(JSON.stringify(term))])
    const percentageOptions=[
        { name: "0%", value: 0  },
        { name: "25%", value: 25  },
        { name: "50%", value: 50  },
        { name: "75%", value: 75  },
        { name: "100%", value: 100  },
    ]

    const paymentType=ref("mensual")

    extend('required', required)
    extend('numeric', numeric)

    if (!store.hasModule(COURSES_MODULE)) { store.registerModule(COURSES_MODULE, courseModule) }

    onUnmounted(() => {
        if (!store.hasModule(COURSES_MODULE)) { store.unregisterModule(COURSES_MODULE) }
    })


    const addNewTerm=() => {
        terms.value.push(JSON.parse(JSON.stringify(term)))
    }

    const removeTerm=(index) => {
        terms.value.splice(index, 1)
    }

    const onSubmit = function() {
        form.value.validate().then(success => {
            if(success){
                document.getElementById('submitbutton').disabled=true;
                store.dispatch('courses/addCourse', {course: JSON.parse(JSON.stringify(data.value)), terms:terms.value, type: paymentType.value})
                    .then(response => { 

                        if (response.data.success) {
                            router.push({ name: 'courses' }) 
                            document.getElementById('submitbutton').disabled=false;

                            successToast(response.data.message)
                        } else {

                            if (response.data.data['course.code']) {
                            errorToast('El código de curso ya existe. Por favor, introduzca otro.')
                            } else {
                                errorToast("Error", response.data.message)
                            }
                            document.getElementById('submitbutton').disabled=false;

                        }
                    })
                    .catch(error => {errorToast('Can\'t update Courses');document.getElementById('submitbutton').disabled=false;})
            }
        })
    }

    store.dispatch('courses/createCourse').then(response => {
        groups.value = response.data.groups
        taxes.value = response.data.taxes
        sections.value = response.data.sections
    })

    watch(paymentType, () => {
        if (paymentType.value=="mensual") {
            terms.value=[JSON.parse(JSON.stringify(term))]
        } else if (paymentType.value=="plazos") {
            data.value.first_month_percentage=null
            data.value.last_month_percentage=null
            data.value.monthly_payment=null
            data.value.start_date=null
            data.value.end_date=null
            
        }
    })

    return {
        getValidationState,
        data,
        onSubmit,
        form,
        groups,
        sections,
        taxes,
        paymentType,
        percentageOptions,
        terms,
        addNewTerm,
        removeTerm
    }
    }
}

</script>

<style lang="scss">
    @import '~@core/scss/vue/libs/vue-select.scss';
    .repeater-form {
    // overflow: hidden;
    transition: 0.35s height;
    }
</style>
